module.exports = __webpack_public_path__ + "img/CH.8af42146.webp";